import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { BodyCopy, TextAreaWithCharacterCounter } from 'secondstep-components'

export const PurposeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-top: 2.063rem;
  margin-bottom: 2.063rem;
`

export const PurposeLabel = styled.label`
  color: ${themeGet('colors.darkGray')};
  text-align: start;
  margin-top: -0.188rem;
  margin-bottom: 0.375rem;
`

export const Example = styled(BodyCopy)`
  color: ${themeGet('colors.darkGray')};
  text-align: start;
  margin-top: 0.438rem;
`

export const StyledTextArea = styled(TextAreaWithCharacterCounter)`
  color: ${themeGet('colors.darkGray')};

  :focus,
  :active {
    border-color: ${themeGet('colors.blue')};
  }
`
